import { NewsletterFrequency } from '../enums/newsletter-frequency';

export const FREQUENCY_NAME: { [key: number]: string } = {
  [NewsletterFrequency.MultiDaily]: 'Multi-Daily',
  [NewsletterFrequency.Daily]: 'Daily',
  [NewsletterFrequency.Weekly]: 'Weekly',
  [NewsletterFrequency.AdHoc]: 'Ad Hoc',
};
